
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"16","viewBox":"0 0 10 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.707 7.293L3.293.879A3 3 0 001.172 0H0v16h1.172a3 3 0 002.12-.879l6.415-6.414a.997.997 0 000-1.414z","fill":"currentColor"}})])
          )
        }
      }
    